import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Button, Card, TextField, Typography } from '@mui/material';
import { GoogleMap, MarkerF } from '@react-google-maps/api';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import useGoogleMap from 'src/hooks/use-google-hook';
import { useApiGet, useApiMutation } from 'src/utils/api/general-service';
import * as Yup from 'yup';

import GoogleSearch from '../AddListingForm/GoogleSearch';

const ListingSettings = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const isUpdate = searchParams.get('update') === '1' ? true : false;
  console.log({ params }, params.id, searchParams.get('update'), isUpdate);
  const queryClient = useQueryClient();

  const listingId = params?.id;
  console.log({ listingId });
  const { enqueueSnackbar } = useSnackbar();

  const defaultValues = {
    address: '',
    unit_no: '',
    city: '',
    state: '',
    zipcode: '',
    area: '',
    country: '',
    lng: '',
    lat: '',
  };
  const validationSchema = Yup.object().shape({});
  // Create Form Context using `useForm`
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const {
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
    setError,
  } = methods; // Destructure required methods from `methods`

  console.log({ reset, getValues, errors, setError });

  const { mutate: updateListingStatus, isLoading: updatingListingStatus } = useApiMutation({
    endpoint: `listing/${listingId}`,
    method: 'post',
    config: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['listing'] });
        enqueueSnackbar('Coordinates updated successfully!', { variant: 'success' });
      },
      onError: () => {
        enqueueSnackbar('Error updating coordinates', { variant: 'error' });
      },
    },
  });

  console.log({ updateListingStatus });
  // Handle form submission
  const onSubmit = useCallback(async (formValues, event) => {
    try {
      const payload = {
        _method: 'PATCH',
        latitude: formValues.latitude,
        longitude: formValues.longitude,
      };
      console.log({ payload });
      updateListingStatus(payload);
      event.preventDefault();
    } catch (err) {
      console.log(err);
    }
  }, []);
  return (
    <Card className="p-12">
      <FormProvider {...methods}>
        <Typography variant="h4" sx={{ pb: 2, mt: 2 }}>
          {isUpdate ? 'Update fake coordinates' : 'Add Fake Location'}
        </Typography>
        <Typography
          variant="body1"
          sx={{ mb: 2, p: 2, backgroundColor: '#f9f9f9', borderRadius: '8px', borderLeft: '4px solid #1976d2' }}
        >
          You can set fake coordinates here that will be displayed on the map. You can either move the marker manually
          or enter a nearby address in the designated field to update the location.
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)}>
          <UpdateCoordinates isUpdate={isUpdate} />
          <div className="flex justify-end mt-4">
            <LoadingButton type="submit" variant="contained" loading={updatingListingStatus}>
              {isUpdate ? 'Update fake coordinates' : 'save coordinates'}
            </LoadingButton>
          </div>
        </form>
      </FormProvider>
    </Card>
  );
};

export default ListingSettings;

const UpdateCoordinates = () => {
  const params = useParams();
  console.log({ params }, params.id);
  const listingId = params?.id;

  const {
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useFormContext(); // Access form context

  const latitude = watch('latitude');
  const longitude = watch('longitude');

  const { isLoaded, onLoad, onUnmount } = useGoogleMap({ latitude, longitude });
  console.log('child component re-render', latitude, longitude);
  const findAddress = () => {
    const latLng = new window.google.maps.LatLng(latitude, longitude);
    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const addressObject = results[0];
        const addressComponents = addressObject?.address_components || [];

        const getComponent = (type) =>
          addressComponents.find((component) => component.types.includes(type))?.long_name || '';

        setValue('address', addressObject.formatted_address);
        setValue('city', getComponent('locality'));
        setValue('state', getComponent('administrative_area_level_1'));
        setValue('country', getComponent('country'));
        setValue('zipcode', getComponent('postal_code'));
        setValue('lat', addressObject.geometry.location.lat());
        setValue('lng', addressObject.geometry.location.lng());
      } else {
        console.error('Geocoder failed due to: ', status);
      }
    });
  };

  const onDragEnd = (e) => {
    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();
    console.log('New position:', { lat: newLat, lng: newLng });

    // Update the form values for latitude and longitude
    setValue('latitude', newLat);
    setValue('longitude', newLng);
  };

  const { isLoading: loadingListing } = useApiGet({
    endpoint: `/listing/${listingId}`,
    queryKey: ['listing', listingId],

    config: {
      select: (data) => {
        return data?.data?.listing;
      },
      enabled: !!listingId,
      onSuccess: (res) => {
        const {
          address,
          unit_no,
          city,
          state,
          zipcode,
          area,
          country,
          longitude,
          latitude,
          fake_longitude,
          fake_latitude,
        } = res || {};
        console.log('resseting......');
        reset({
          listing_type: res?.listing_type?.toLowerCase(),

          address,
          unit_no: unit_no,
          city,
          state,
          zipcode,
          area,
          country,
          longitude: fake_longitude || longitude,
          latitude: fake_latitude || latitude,
        });
      },
    },
  });

  if (loadingListing || !isLoaded) return 'Loading...';

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-1">
          <Controller
            name="address"
            control={control}
            render={({ field: { onChange, value } }) => (
              <div className="flex flex-col gap-1 relative">
                <GoogleSearch
                  id="address"
                  isLoaded={isLoaded}
                  onChange={(address) => {
                    onChange(address?.address ?? address);
                    if (address?.address) {
                      // Set form values
                      setValue('address', address.address);
                      setValue('city', address.city, { shouldValidate: true });
                      setValue('state', address.state, { shouldValidate: true });
                      setValue('country', address.country, { shouldValidate: true });
                      setValue('zipcode', address.zipcode, { shouldValidate: true });
                      setValue('latitude', address?.latitude, { shouldValidate: true });
                      setValue('longitude', address?.longitude, { shouldValidate: true });
                    }
                  }}
                  value={value}
                  error={!!errors?.address?.message}
                  helperText={errors?.address?.message}
                />
              </div>
            )}
          />
        </div>
        <div className="col-span-1">
          <Controller
            name="unit_no"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="unit_no"
                label="Apartment/Suite (Optional)"
                value={value}
                onChange={onChange}
                type="number"
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.unit_no?.message}
                helperText={errors?.unit_no?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-4">
        <div className="col-span-1">
          <Controller
            name="city"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="city"
                label="City"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.city?.message}
                helperText={errors?.city?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>

        <div className="col-span-1">
          <Controller
            name="state"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="state"
                label="State"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.state?.message}
                helperText={errors?.state?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>

        <div className="col-span-1">
          <Controller
            name="zipcode"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="zipcode"
                label="ZIP / Postal Code"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.zipcode?.message}
                helperText={errors?.zipcode?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-4">
        <div className="col-span-1">
          <Controller
            name="area"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="area"
                label="Area (Optional)"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.area?.message}
                helperText={errors?.area?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>

        <div className="col-span-1">
          <Controller
            name="country"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="country"
                label="Country"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.country?.message}
                helperText={errors?.country?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 mt-4">
        <div className="col-span-1">
          <div style={{ width: '100%', height: '500px', borderRadius: '8px', overflow: 'hidden' }}>
            <GoogleMap
              mapContainerStyle={{ width: '100%', height: '100%' }}
              center={{ lat: +latitude || 40.7128, lng: +longitude || -74.006 }}
              zoom={20}
              onLoad={onLoad}
              onUnmount={onUnmount}
            >
              <MarkerF
                onDragEnd={onDragEnd}
                draggable
                position={{ lat: +latitude || 40.7128, lng: +longitude || -74.006 }}
              />
            </GoogleMap>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4  mt-4">
        <div className="col-span-1">
          <Controller
            name="latitude"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="latitude"
                label="Latitude"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.latitude?.message}
                helperText={errors?.latitude?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>

        <div className="col-span-1">
          <Controller
            name="longitude"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                id="longitude"
                label="Longitude"
                value={value}
                onChange={onChange}
                variant="outlined"
                sx={{ width: '100%', textAlign: 'left' }}
                error={!!errors?.longitude?.message}
                helperText={errors?.longitude?.message}
                InputLabelProps={{ ...(value && { shrink: true }) }}
              />
            )}
          />
        </div>
        <div className="col-span-1">
          <Button fullWidth variant="outlined" onClick={findAddress} sx={{ height: '100%' }}>
            Find Address
          </Button>
        </div>
      </div>
    </>
  );
};
